import { ElegibilidadeCarrosselSubarcas } from './elegibilidade-carrossel-sub-marcas.config.types';

export const getElegivelCarrosselSubmarcasConfig: ElegibilidadeCarrosselSubarcas = ({ marca }) => {
  return marca === 'wyden';
};
